import axios from 'axios';
import storage from './storage';
import RSA from './useRSA';
import AES from './public';
import FIX from './fixed';

// let baseUrl = "http://172.16.4.239:8008"; // 辉县地区测试
// let baseUrl = 'http://192.168.2.226:9023'; // 测试
// let baseUrl = 'http://192.168.20.11:7000'; // 吕
let baseUrl = 'https://openapi.zzkyt.cn'; // 生产地址
// let baseUrl = "https://openapi.lnkyt.cn"; // 新测试地址

export { baseUrl };
// 上传接口
let uploadUrl = baseUrl + '/zzsoft/openApi/v1/file/modeImpFile.fix';
// 获取token的接口
let tokenUrl = baseUrl + '/zzsoft/openApi/v1/token/getToken.fix';
//业务接口
let mainUrl = baseUrl + '/zzsoft/openApi/v1/modeward/forward.fix';
//导出地址
let outUrl = baseUrl + '/zzsoft/openApi/v1/file/modeExpFile.fix';
// 公钥
const rsaPubKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvfVbYmWdDVLzCY4x4Akcf6P7mBAZq3KbdxhYXNQXULf7d6kijDOXnysgGCy0ZQUTzhk9rOaPSyOTcMvDYPkVgWx7K3K6Ou4Fi9qSDdn0Daf1DWSp5eV5BDFOxQu1aF+6aL4/ZpM1yHrZ6BnA4mI+cpXZ4a+m1UNxaAgcZlrOTK3TU1g42OWZrmM3exJqO8UPnE2eXAKT8iuW5DUfT16SYlE2OO7V7matGlGXD/EYsf3MOKKiAYQbDYfN6YensVwL/i9hhuxsQsge5/LG0l5QV2F9ko8XTGgCJawI1e+Ak7DDtr5XiHZW2pYClQN6QtW0Pa4Y8Ki0VVOSUu3HApFAoQIDAQAB';
//系统唯一appId
const appId = 'GxASW0PudlA3TEszS6Ku';

let http = {};
http.ajax = axios.create({
  baseURL: '',
  timeout: 16000, // 请求超时时间
  headers: {
    'content-type': 'application/x-www-form-urlencoded'
  }
});

// token过期时再次获取
http.getToken = (params) => {
  return new Promise((resolve, reject) => {
    // AES 加密数据
    let aes_key = FIX.random(16);
    // AES_IV
    let aes_iv = FIX.random(16);
    let nonce = FIX.random(32);
    // 时间戳
    let timestamp = FIX.timeStamp();
    let sign_mw = '{"appId":"' + appId + '","nonce":"' + nonce + '", "timestamp": "' + timestamp + '"}';
    // aes 使用 aes_key aes_iv 加密 sign
    let sign = AES.encrypt(sign_mw, aes_key, aes_iv);
    // rsa 公钥加密AES的密码和偏移
    // rsa 公钥加密 aes_key + aes_iv
    let secret = RSA.RSAEncrypt(aes_key, aes_iv, rsaPubKey);
    // RSA.ende
    const sendData = {
      appId: appId,
      secret: secret,
      sign: sign
    };
    http.ajax
      .post(tokenUrl, JSON.stringify(sendData))
      .then((res) => {
        if (res.status == 200) {
          // code=1请求成功
          if (res.data.code == 1) {
            let get_secret = res.data.data.secret;
            let token_miwen = res.data.data.token;
            let token_mingwen = AES.decrypt(get_secret, token_miwen);
            storage.set('token', token_mingwen);
            // 如果有参数再次调用参数
            if (params) {
              http.post(params); // 拿到token后再次请求接口
            }
          }
        } else {
          reject(res.status || '失败');
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// 业务接口;
http.post = (params) => {
  return new Promise((resolve, reject) => {
    // 获取token
    let token = storage.get('token');
    // 如果本地没有token先获取token
    if (!token) {
      http.getToken(params);
      return;
    }
    // 加密处理
    let aes_key = FIX.random(16); // aes 密钥
    let aes_iv = FIX.random(16); // aes 偏移
    let nonce = FIX.random(32); // nonce
    let timestamp = FIX.timeStamp(); // 时间戳
    let secret = RSA.RSAEncrypt(aes_key, aes_iv, rsaPubKey); // secret
    // 参数赋值
    params.token = token;
    params.appId = appId;
    params.nonce = nonce;
    params.timestamp = timestamp;
    // 对所有参数进行加密
    let sign = AES.encrypt(JSON.stringify(params), aes_key, aes_iv);
    // 最终处理的参数
    let sendData = {
      appId: appId,
      secret: secret,
      sign: sign
    };
    http.ajax
      .post(mainUrl, JSON.stringify(sendData))
      .then((res) => {
        if (res.status == 200) {
          // token过期重新获取token后继续走业务接口
          if (res.data.code == -17 || res.data.code == -18 || res.data.code == -19 || res.data.code == -20) {
            http.getToken(params);
            return;
          } else if (res.data.code == -1 && res.data.msg == 'Request Http Service Error!') {
            console.log('接口请求错误! ModeCode: ' + params.modeCode);
            reject('请求地址或参数错误');
          } else {
            // code = 1 请求成功
            resolve(res.data);
          }
        } else {
          reject('失败');
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

//导出接口
http.exportMethod = (params) => {
  return new Promise((resolve, reject) => {
    // 从本地中取出token
    let token = storage.get('token');
    // 加密处理
    let aes_key = FIX.random(16); // aes 密钥
    let aes_iv = FIX.random(16); // aes 偏移
    let nonce = FIX.random(32); // nonce
    let timestamp = FIX.timeStamp(); // 时间戳
    let secret = RSA.RSAEncrypt(aes_key, aes_iv, rsaPubKey); // secret
    // 参数赋值
    params.token = token;
    params.appId = appId;
    params.nonce = nonce;
    params.timestamp = timestamp;
    // 对所有参数进行加密
    let sign = AES.encrypt(JSON.stringify(params), aes_key, aes_iv);
    // 最终处理的参数
    let sendData = {
      appId: appId,
      secret: secret,
      sign: sign
    };
    http.ajax
      .post(outUrl, JSON.stringify(sendData), {
        responseType: 'blob'
      })
      .then((res) => {
        if (res.data.code == 2) {
          return;
        }
        const link = document.createElement('a');
        let blob = new Blob([res.data], {
          type: 'application/x-msdownload'
        });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.download = params.fileName + '.' + params.suffix; // 下载的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// 上传图片
http.upload = (params, base64) => {
  return new Promise((resolve, reject) => {
    //从本地中取出token
    let token = storage.get('token');
    // 加密处理
    let aes_key = FIX.random(16); // aes 密钥
    let aes_iv = FIX.random(16); // aes 偏移
    let nonce = FIX.random(32); // nonce
    let timestamp = FIX.timeStamp(); // 时间戳
    let secret = RSA.RSAEncrypt(aes_key, aes_iv, rsaPubKey); // secret
    // 参数赋值
    params.token = token;
    params.appId = appId;
    params.nonce = nonce;
    params.timestamp = timestamp;
    // 对所有参数进行加密
    let sign = AES.encrypt(JSON.stringify(params), aes_key, aes_iv);
    // 最终处理的参数
    let sendData = {
      appId: appId,
      secret: secret,
      sign: sign,
      file: base64 // base64格式的文件
    };
    http.ajax
      .post(uploadUrl, JSON.stringify(sendData))
      .then((res) => {
        if (res.status == 200) {
          // code=1请求成功
          if (res.data.code == 1) {
            resolve(res.data);
          } else if (res.data.code == -60) {
            storage.remove('userInfo');
            return;
          } else if (res.data.code == -17 || res.data.code == -18 || res.data.code == -19 || res.data.code == -20) {
            //token过期重新获取token后继续走业务接口
            http.getToken(params);
            return;
          } else {
            resolve(res.data);
          }
        } else {
          reject(res.status || '失败');
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default http;
